// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-breadcrumbs-collections-structure-breadcrumbs__item {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Breadcrumbs/CollectionsStructureBreadcrumbs/CollectionsStructureBreadcrumbs.scss"],"names":[],"mappings":"AACI;EACI,YAAA;AAAR","sourcesContent":[".dl-breadcrumbs-collections-structure-breadcrumbs__item {\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
